<template>
  <cus-order-dialog>
    <template v-slot:body>
      <div class="body-wrap">
        <div class="work-list">
          <!--  Bar 日結-->
          <div class="daily-bar" v-if="name === 'dailyRecord'">
            <div class="section" :style="`grid-template-columns: repeat(${sectionList.length}, 1fr)`">
              <p
                v-for="(section, index) in sectionList"
                :key="index"
                :class="selectSection === section ? 'select' : ''"
                @click="handleClickSection(section)"
              >
                {{ section }}班
              </p>
            </div>
            <div class="section">
              <p :class="selectSection === 'day' ? 'select' : ''" @click="handleClickSection('day')">當日(已清帳)</p>
            </div>
          </div>
          <!--  Bar 清帳-->
          <div class="section" v-if="name === 'squareRecord'">
            <p class="select">{{ getSystem?.section }}班</p>
          </div>
          <!-- 明細 -->
          <div class="work-detail">
            <div class="box-bg" style="grid-area: 1/1/3/2">
              <p class="box-title">營業資訊</p>
              <div class="content-wrap info">
                <p>
                  營業日期：
                  <br />
                  {{ formatDateTime('YYYY/MM/DD', getRecord?.date) }}
                </p>
                <p>
                  機台：
                  <br />
                  {{ getRecord?.client_id }}
                </p>
                <p>
                  班別：
                  <br />
                  {{ selectSection === 'day' ? '當日' : getRecord?.section_id }}
                </p>
                <p>
                  交易序號（起）：
                  <br />
                  {{ getRecord?.start_serial_number }}
                </p>
                <p>
                  交易序號（迄）：
                  <br />
                  {{ getRecord?.end_serial_number }}
                </p>
                <p>
                  發票號碼（起）：
                  <br />
                  {{ getRecord?.start_invoice_no }}
                </p>
                <p>
                  發票號碼（迄）：
                  <br />
                  {{ getRecord?.end_invoice_no }}
                </p>
              </div>
            </div>
            <div
              v-for="(obj, index) in Object.keys(details)"
              :key="index"
              class="box-bg"
              :style="`grid-area:${details[obj].grid}`"
            >
              <p class="box-title">{{ details[obj].title }}</p>
              <div class="content-wrap">
                <div v-for="(item, index) in details[obj].items" :key="index" :class="['content', item.color]">
                  <p :class="item.label.length > 9 ? 'small' : ''">{{ item.label }}：</p>
                  <p>{{ getRecord ? getRecord[item.value] : '' }}</p>
                </div>
                <div v-if="details[obj].summary" class="line"></div>
                <div v-if="obj === 'sales_total'" class="summary">
                  ＝銷售總淨額：
                  <span style="font-size: 1.8rem"></span>
                  <span>
                    {{
                      getRecord?.order_total_amount +
                      getRecord?.redundant_cash -
                      getRecord?.order_total_discount -
                      getRecord?.total_discount
                    }}
                  </span>
                </div>
                <div v-if="obj === 'invoice'" class="summary">
                  ＝電子發票總金額：
                  <span style="font-size: 1.8rem"></span>
                  <span>
                    {{
                      getRecord?.invoice_total_sales_amount +
                      getRecord?.invoice_total_tax_amount +
                      getRecord?.invoice_total_free_tax_amount
                    }}
                  </span>
                </div>
                <div v-if="obj === 'check'">
                  <div class="summary">
                    ＝抽屜應有現金：
                    <span style="font-size: 1.8rem"></span>
                    <span>{{ needCash }}</span>
                  </div>
                  <div class="summary" :class="needCash === getRecord?.cash_box ? '' : 'red'">
                    {{ needCash === getRecord?.cash_box ? '＝' : '≠' }}實際抽屜現金：
                    <span style="font-size: 1.8rem"></span>
                    <span>{{ getRecord?.cash_box }}</span>
                  </div>
                  <div v-if="needCash !== getRecord?.cash_box">
                    <div class="line"></div>
                    <div class="summary red">
                      <span style="font-size: 1.8rem">現金差額</span>
                      <span>{{ getRecord?.cash_box - needCash }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="d-flex">
        <cus-button
          :text="name === 'dailyRecord' ? '關閉' : '完成'"
          :color="name === 'dailyRecord' ? 'white' : 'blue'"
          :width="50"
          @click="handleComplete"
          :style="`order: ${name === 'dailyRecord' ? 0 : 1}`"
        ></cus-button>
        <cus-button
          :text="`列印報表${
            name === 'dailyRecord' ? `（${selectSection === 'day' ? '當日' : selectSection + '班'}）` : ''
          }`"
          :color="name === 'dailyRecord' ? 'blue' : 'white'"
          :width="50"
          @click="handlePrint"
        ></cus-button>
      </div>
    </template>
  </cus-order-dialog>
</template>
<script>
import { ref, inject, reactive, getCurrentInstance, computed } from 'vue';
import { useGetters, useActions } from '@/utils/mapStore';
import { formatDateTime } from '@/utils/datetime';
import { useRoute } from 'vue-router';
export default {
  name: 'accounting',
  setup() {
    const { proxy } = getCurrentInstance();
    //接受provide參數
    const name = inject('order_name');
    const close = inject('order_close');
    const controlCloseButton = inject('order_controlCloseButton');
    //如果是強制清帳，必須把叉叉關掉
    const getSystem = useGetters('system', ['getSystem']);
    if (getSystem.value?.show_alert_type === 2) {
      controlCloseButton(true);
    }
    //參數
    const details = reactive({
      dayungs_pay: {
        grid: '1/2/2/3',
        title: '大苑子支付',
        items: [
          { label: '旺卡', value: 'want_card' },
          { label: '黃金點數', value: 'want_card_point' },
          { label: '現金卡', value: 'cash_card' },
          { label: '外送行動支付', value: 'payment_by_outside_payment_app' },
        ],
      },
      sales: {
        grid: '2/2/3/3',
        title: '銷售統計',
        items: [
          { label: '訂單筆數', value: 'order_count' },
          { label: '銷售數−杯數', value: 'order_item_count' },
          { label: '銷售數−產品數', value: 'order_product_count' },
          { label: '銷售數−周邊商品', value: 'order_other_product_count' },
          { label: '自備杯獎勵(現金)筆數', value: 'event_cash_count' },
          { label: '自備杯獎勵(現金)金額', value: 'event_cash_amount' },
          { label: '自備杯獎勵(旺卡)筆數', value: 'event_card_count' },
          { label: '自備杯獎勵(旺卡)金額', value: 'event_card_amount' },
        ],
      },
      other_pay: {
        grid: '1/3/3/4',
        title: '其他支付',
        items: [
          { label: '現金', value: 'cash' },
          { label: 'Line Pay', value: 'line_pay' },
          { label: 'iPASS MONEY', value: 'i_pass_pay' },
          { label: '街口支付', value: 'jeko' },
          { label: '台灣Pay', value: 'taiwan_pay' },
          { label: '支付寶', value: 'ali_pay' },
          { label: '悠遊付', value: 'uupay' },
          { label: '信用卡', value: 'credit_card' },
          { label: '一卡通', value: 'i_pass' },
          { label: '悠遊卡', value: 'easy_card' },
          { label: 'FoodPanda', value: 'foodpanda' },
          { label: 'UberEats', value: 'uber_eat' },
          { label: 'Foodomo', value: 'foodomo' },
          { label: 'line@訂餐', value: 'line' },
          { label: '禮券', value: 'gift_certificate' },
          { label: '園區員工卡', value: 'park_employee_card' },
          { label: 'PandaGo代收', value: 'panda_go' },
        ],
      },
      sales_total: {
        grid: '1/4/2/5',
        title: '銷售總計',
        items: [
          { label: '銷售總金額(+)', value: 'order_total_amount' },
          { label: '折扣金額(−)', value: 'order_total_discount' },
          { label: '折抵金額(−)', value: 'total_discount' },
          { label: '溢收(+)', value: 'redundant_cash' },
        ],
        summary: true,
      },
      invoice: {
        grid: '2/4/3/5',
        title: '發票總計',
        items: [
          { label: '作廢筆數', value: 'void_invoice_count' },
          { label: '作廢總金額', value: 'void_invoice_total_amount' },
          { label: '應稅銷售額(+)', value: 'invoice_total_sales_amount' },
          { label: '應稅稅額(+)', value: 'invoice_total_tax_amount' },
          { label: '免稅銷售額(+)', value: 'invoice_total_free_tax_amount' },
        ],
        summary: true,
      },
      note: {
        grid: '1/5/2/6',
        title: '其他記錄',
        items: [
          { label: '旺卡加值', value: 'want_card_add' },
          { label: '旺卡退值', value: 'want_card_refund' },
          { label: '掛單更正商品數', value: 'order_item_reedit_count' },
          { label: '掛單更正總金額', value: 'order_item_reedit_amount' },
          { label: '開櫃次數', value: 'open_cash_box_count' },
        ],
      },
      check: {
        grid: '2/5/3/6',
        title: '現金核對',
        items: [
          { label: '應收現金(+)', value: 'current_cash' },
          { label: '雜支(−)', value: 'other_expense' },
        ],
        summary: true,
      },
    });
    //抽屜應有現金(應收現金-雜支)
    const needCash = computed(() => getRecord.value?.current_cash - getRecord.value?.other_expense);

    //取得班號與建立當天的班號清單
    const doGetDutySection = useActions('system', ['doGetDutySection']);
    const sectionList = computed(() => {
      let arr = [];
      if (getSystem.value) {
        for (let i = 1; i <= Number(getSystem.value.section); i++) {
          arr.push(`${i < 10 ? '0' + i : i}`);
        }
      }
      return arr;
    });
    const selectSection = ref(null);
    //初始化
    const getRecord = useGetters('accounting', ['getRecord']);
    const doGetRecord = useActions('accounting', ['doGetRecord']);
    const handleDutySection = (async function () {
      await doGetDutySection();
      if (name.value === 'dailyRecord') {
        //日結
        selectSection.value = sectionList.value[0];
        doGetRecord({ date: getSystem.value.date, section_id: selectSection.value });
      } else {
        //交班
        selectSection.value = getSystem.value.section;
        doGetRecord({ date: getSystem.value.date, section_id: getSystem.value.section });
      }
    })();
    //選擇班別
    const handleClickSection = async (section) => {
      await doGetRecord({
        date: getSystem.value.date,
        section_id: section === 'day' ? '' : section,
      });
      selectSection.value = section;
    };
    //列印報表
    const printReport = useActions('accounting', ['printReport']);
    const handlePrint = () => {
      printReport({
        date: getSystem.value.date,
        section_id: selectSection.value === 'day' ? '' : selectSection.value,
      });
    };
    //關閉或完成
    const doLogout = useActions('system', ['doLogout']);
    const shiftComplete = useActions('accounting', ['shiftComplete']);
    const route = useRoute();
    const handleComplete = async () => {
      //交班
      if (name.value === 'squareRecord') {
        await shiftComplete();
        if (route.fullPath !== '/login') {
          proxy
            .$message('交班清帳成功', '', {
              image: require('@/assets/images/icon-pass.png'),
              hideClose: true,
              confirmText: `確定並登出`,
            })
            .then(() => {
              doLogout();
            });
        }
      }
      close();
    };
    return {
      formatDateTime,
      name,
      close,
      details,
      needCash,
      selectSection,
      getSystem,
      sectionList,
      handleDutySection,
      getRecord,
      handleClickSection,
      handlePrint,
      handleComplete,
    };
  },
};
</script>
<style lang="scss" scoped>
$bar-height: 6vh; //bar高度
$title-height: 5vh; //標題高度
.body-wrap {
  position: relative;
  padding: 0 4px;
}
.work-list {
  height: 100%;
  display: grid;
  grid-template-rows: $bar-height auto;
  grid-gap: 8px;
  .daily-bar {
    display: grid;
    grid-template-columns: 2fr 0.7fr;
    grid-column-gap: 8px;
  }
  .section {
    width: 100%;
    background-color: $color-gray-6;
    border-radius: 27px;
    text-align: center;
    font-size: 2.2rem;
    color: $color-blue;
    display: grid;
    p {
      line-height: $bar-height;
      transition: 0.2s;
      border-radius: 27px;
      cursor: pointer;
    }
    p.select {
      background-color: $color-blue;
      color: #fff;
    }
  }
  .work-detail {
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 20%));
    grid-template-rows: min-content auto;
    grid-gap: 8px;
    .box-bg {
      border-radius: 4px;
      border: 2px solid $color-gray-10;
      background-color: $color-gray-3;
      font-size: 1.8rem;
    }
    .box-title {
      text-align: center;
      border-bottom: 2px solid $color-gray-10;
      background-color: $color-gray-3;
      height: $title-height;
      line-height: $title-height;
    }
    .content-wrap {
      padding: 8px 12px;
      height: calc(100% - $title-height);
      .content {
        width: 100%;
        @include flex-between-center;
        p {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          line-height: 3rem;
        }
      }
      .small {
        font-size: 1.5rem;
      }
      .line {
        margin: 8px 0;
        width: 100%;
        border-bottom: 2px solid $color-gray-10;
      }
      .summary {
        color: $color-green;
        @include flex-between-center;
      }
      .red {
        color: $color-error;
      }
    }
    .info p {
      font-size: 1.9rem;
      line-height: 3.5rem;
    }
  }
}
</style>
